import { useState, useEffect } from "react";
import { fetchPaymentCategories } from "@/services/financeiro";

/**
 * Busca os Planos Financeiros do Sienge (payment categories).
 * Retorna Map<categoryId, categoryName>.
 * O fetch é feito uma única vez; o estado persiste enquanto o componente estiver montado.
 */
export function usePaymentCategories(): Map<string, string> {
  const [map, setMap] = useState<Map<string, string>>(new Map());

  useEffect(() => {
    let cancelled = false;
    fetchPaymentCategories().then((m) => {
      if (!cancelled) setMap(m);
    });
    return () => { cancelled = true; };
  }, []);

  return map;
}
